/**
 * Top bar element in header
 */
export function topBar (){

	const topbar = document.querySelector( '.page-header__topbar' )


	/**
	 * Function to set the visibility status of the top bar in the application.
	 *
	 * @param {boolean} visible - Whether the top bar should be visible or not.
	 */
	const setTopBarVisibility = visible => {

		if ( visible ) {

			sessionStorage.setItem( `topBarVisible`, 'true' );

		} else {

			sessionStorage.setItem( `topBarVisible`, 'false' );

		}

	};

	/**
	 * Function to close the topbar by hiding it.
	 * When the close button in the topbar is clicked, it sets the topbar visibility to false,
	 * updates the topbar height to 0px, and hides the topbar element.
	 */
	const closeTopbar = () => {

		const closeTopbarButton = document.querySelector( '.js-close-topbar' );
		if ( closeTopbarButton ) {

			closeTopbarButton.addEventListener( 'click', () => {

				setTopBarVisibility( false )
				document.documentElement.style.setProperty( '--topbar-height', `0px` );
				topbar.style.display = 'none'

			} )

		}

	}

	closeTopbar()


	/**
	 * Checks the visibility of the top bar and updates the DOM accordingly.
	 * Retrieves the visibility value from sessionStorage and sets the top bar height and display property based on the value.
	 */
	const checkTopBarVisibility = () => {

		const topBarVisible = sessionStorage.getItem( `topBarVisible` );

		if ( topBarVisible === 'false' ) {

			document.documentElement.style.setProperty( '--topbar-height', `0px` );
			if ( topbar ) {

				topbar.style.display = 'none'

			}

		} else if ( topbar ) {

			topbar.style.display = 'flex'

		}

	};

	checkTopBarVisibility();

}

